(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dc-whatsapp-floating"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('dc-store-assistant')){
class DCStoreAssistant extends HTMLElement{
connectedCallback(){
const teaser=this.querySelector('[data-teaser]');
try{teaser.hidden=sessionStorage.getItem('dc-assistant-dismissed')==='1';}catch{}
this.querySelector('[data-dismiss]').addEventListener('click',()=>{teaser.hidden=true;try{sessionStorage.setItem('dc-assistant-dismissed','1');}catch{}});
const panel=this.querySelector('[popover]');
panel.addEventListener('toggle',event=>{if(event.newState==='open'){teaser.hidden=true;try{sessionStorage.setItem('dc-assistant-dismissed','1');}catch{}}});
}
}
customElements.define('dc-store-assistant',DCStoreAssistant);
}
  } catch(e) { console.error(e); }
})();

})();
